import { type CoreEventBus } from '@databases/core-event-bus';
import type { FlagsManager } from '@databases/flags-types';
import type { PanelManager } from '@databases/panel-types';
import type { PluginsChecker } from '@databases/plugins-types';
import { type IntlShape } from 'react-intl-next';

import { type PreviewPanelAFMBridge } from '@canvas/databases-bridge-api';

import { ServiceContainer } from './service-container';
import { type FactoryFunction } from './types';

export type ContainerServices = {
  EventBus: CoreEventBus;
  FlagsManager: FlagsManager;
  Intl: IntlShape;
  PanelManager: PanelManager;
  PluginsManager: PluginsChecker;
  PreviewPanelAFMBridge: PreviewPanelAFMBridge;
};

export type ContainerOverrideOptions = {
  [K in keyof Omit<ContainerServices, 'EventBus'>]: FactoryFunction<
    ContainerServices,
    ContainerServices[K]
  >;
};

export const container = new ServiceContainer<ContainerServices>();
